/* eslint-disable default-case */
import { user } from '../constants';
import produce from 'immer';

const emailChecker = emailPrefix => {
  const expectedPrefix = 'tigergraph.com';
  return emailPrefix === expectedPrefix;
};

const userInitialState = {
  profile: JSON.parse(localStorage.getItem('userProfile')) || {
    isAdmin: false,
    token: '',
    maxLicenseDay: 0
  },
  accessToken: localStorage.getItem('accessToken') || '',
  isEmailValid: (() => {
    const profile = JSON.parse(localStorage.getItem('userProfile'));
    if (!profile || !profile.email) return false;
    const emailParts = profile.email.split('@');
    return emailParts.length === 2 ? emailChecker(emailParts[1]) : false;
  })(),
  isLoggedIn: !!localStorage.getItem('accessToken'),
  isLoggedOut: !localStorage.getItem('accessToken'),
  isFetchingUserProfile: false,
  error: ''
};

// Immer Docs: https://immerjs.github.io/immer/docs/return

const userReducer = produce((draft, action) => {
  switch (action.type) {
    case user.SAVE_USER_TOKEN: {
      draft.accessToken = action.token;
      localStorage.setItem('accessToken', action.token);
      return;
    }
    // Save profile from Google OAuth.
    case user.SAVE_USER_PROFILE: {
      draft.profile = action.profile;
      localStorage.setItem('userProfile', JSON.stringify(action.profile));
      return;
    }
    case user.FETCH_USER_PROFILE_REQUEST: {
      draft.error = '';
      draft.isFetchingUserProfile = true;

      return;
    }
    // Fetch profile from license-tracker server.
    // The profile from server is different with that one from Google.
    case user.FETCH_USER_PROFILE_SUCCESS: {
      draft.profile.isAdmin = action.profile.isAdmin;
      draft.profile.token = action.profile.token;
      draft.profile.maxLicenseDay = action.profile.maxLicenseDay;
      draft.isFetchingUserProfile = false;

      return;
    }
    case user.FETCH_USER_PROFILE_FAILURE: {
      draft.error = action.error;
      draft.isFetchingUserProfile = false;

      return;
    }
    case user.USER_LOG_IN: {
      draft.isLoggedIn = true;
      draft.isLoggedOut = false;

      return;
    }
    case user.USER_LOG_OUT: {
      draft.isLoggedIn = false;
      draft.isLoggedOut = true;
      draft.isEmailValid = false;
      draft.accessToken = '';
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userProfile');
      return;
    }
    case user.CHECK_EMAIL_VALIDITY: {
      draft.isEmailValid = action.isEmailValid;

      return;
    }
  }
}, userInitialState);

export default userReducer;
